import { getPromotionTypeForModel, isMonetary } from './promotion-type';
import { getPromotionDetailTypeForModel, isOnOrdersOver } from './promotion-detail';

export const isCurrencyRequired = model =>
  (model.promotionType && isMonetary(model.promotionType)) ||
  (!model.promotionType && isMonetary(getPromotionTypeForModel(model))) ||
  (model.promotionDetailType && isOnOrdersOver(model.promotionDetailType)) ||
  (!model.promotionDetailType && isOnOrdersOver(getPromotionDetailTypeForModel(model)));
